<div class="app-shell">
  <main class="app-main">
    <router-outlet></router-outlet>
  </main>
  <app-legal-footer></app-legal-footer>
</div>
